import React, { useState } from 'react';
import { Linkedin, Instagram, Facebook, Twitter } from 'lucide-react';

interface FooterProps {
  bgColor?: string;
  textColor?: string;
}

const Footer: React.FC<FooterProps> = ({ 
  bgColor = "bg-white", 
  textColor = "text-gray-800" 
}) => {
  const [hoveredIcon, setHoveredIcon] = useState<number | null>(null);

  const socialIcons = [
    { 
      name: "LinkedIn", 
      Icon: Linkedin,
      hoverColor: "hover:text-blue-600",
      href:'https://www.linkedin.com/company/a-o-smith-india/posts/?feedView=all'
    },
    { 
      name: "Instagram", 
      Icon: Instagram,
      hoverColor: "hover:text-pink-600",
      href:'https://www.instagram.com/aosmithindia?igsh=OGExazNwbXd0bHFi'
    },
    { 
      name: "Facebook", 
      Icon: Facebook,
      hoverColor: "hover:text-blue-700",
      href:' https://www.facebook.com/aosmithin'
    },
    { 
      name: "Twitter", 
      Icon: Twitter,
      hoverColor: "hover:text-sky-500",
      href:'https://x.com/aosmithin?s=11&t=mvZ2Bl3OabgHyXyph1s_AA'
    }
  ];

  return (
    <footer
      className={`fixed bottom-0 left-0 right-0 w-full ${bgColor} ${textColor} py-4 z-50  
                 border-t border-gray-200 shadow-lg`}
    >
      <div className="flex items-center justify-between mx-4 md:mx-5 lg:mx-9 xl:mx-10">
        {/* Left side - Company info */}
        <div className="flex flex-col space-y-1">
          <p className="text-base md:text-lg font-semibold text-gray-900">
            A. O. Smith
          </p>
          <p className="text-xs md:text-sm text-gray-600">
            © 2026 All Rights Reserved
          </p>
        </div>

        {/* Center - Professional divider line (hidden on mobile) */}
        <div className="hidden lg:flex items-center flex-1 max-w-xs mx-6">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
        </div>

        {/* Right side - Social icons */}
        <div className="flex gap-2 md:gap-3 items-center">
          {socialIcons.map((social, index) => {
            const { Icon } = social;
            return (
              <button
                onClick={() => window.open(social.href, '_blank')}
                key={index}
                className={`group relative p-2 rounded-lg border border-gray-200 
                           bg-white hover:bg-gray-50 hover:border-gray-300 hover:shadow-md
                           transition-all duration-200 ${social.hoverColor}
                           focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50`}
                onMouseEnter={() => setHoveredIcon(index)}
                onMouseLeave={() => setHoveredIcon(null)}
                aria-label={`Visit our ${social.name} page`}
              >
                <Icon 
                  size={18} 
                  className="text-gray-600 group-hover:text-current transition-colors duration-200" 
                />
                
                {/* Professional tooltip */}
                <div className={`absolute -top-11 left-1/2 transform -translate-x-1/2 px-2 py-1 
                               bg-gray-800 text-white text-xs rounded font-medium opacity-0 pointer-events-none
                               transition-opacity duration-200 whitespace-nowrap
                               ${hoveredIcon === index ? 'opacity-100' : ''}`}>
                  {social.name}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 
                                 border-l-[4px] border-r-[4px] border-t-[4px] border-transparent border-t-gray-800"></div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Additional professional touch - subtle bottom border */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
    </footer>
  );
};

export default Footer;